import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';

const Address = inject("stores") (
    observer (
        class Address extends Component {

            constructor(props) {
                super();
                this.props = props;
                this.storeUi = this.props.stores.storeUi;
            }

            render() {
                return (
                    <React.Fragment>
                        <div class="content">
                            <h3>Linda Boccara</h3>
                            <span class="data"><a href="tel:+31653932410">+31 (0) 6 539 324 10</a></span>
                            <span class="data"><a href="mailto:linda.boccara@amsterdamlabels.nl">linda.boccara@amsterdamlabels.nl</a></span>
                            <span class="data"><a href="https://www.instagram.nl/amsterdam_labels">Instagram</a></span>
                        </div>
                        {this.props.hide_showroom !== null && !this.props.hide_showroom && 
                            <div class="content">
                                <h3>Showroom</h3>
                                <span class="data">Amsterdam Labels</span>
                                <span class="data">Bulb Spaces</span>
                                <span class="data">Leidsevaartweg 1</span>
                                <span class="data">2106 NA Heemstede</span>
                            </div>
                        }
                    </React.Fragment>
                )
            }
        }
    )
)
        
export default Address;